// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB4zLtcx9DJe0vWnGwQMQbPaiSQtmuS1cs",
  authDomain: "castive-prod.firebaseapp.com",
  projectId: "castive-prod",
  storageBucket: "castive-prod.firebasestorage.app",
  messagingSenderId: "641366440055",
  appId: "1:641366440055:web:edb9b07feda6fa2b8bee72",
  measurementId: "G-9MN2L0JBF8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };